import React, { useEffect } from "react";
import { Modal } from "react-responsive-modal";
import Loader from "components/Loader";
import TopicFooter from "./TopicFooter";
import { ReactComponent as CancelIcon } from "assets/img/icons/cancel.svg";
import * as moment from "moment";

const styles = {
  topicTitleRoot: {
    flex: "0 0 auto",
    margin: "0",
    padding: "10px 13px",
  },
  root: {
    backgroundColor: "#f1f1f1!important",
    color: "#000000ab",
    borderRadius: "8px",
  },
  topicHeading: {
    color: "black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "5px 0",
    fontSize: "1.25rem",
    fontWeight: "500",
  },
  topicTitle: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  userAvatar: {
    paddingRight: "5px",
    width: "30px",
    height: "30px",
  },
  avatarClass: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    objectFit: "cover",
  },
  userName: {
    fontSize: "larger",
    fontWeight: "400",
  },
  topicLoader: {
    height: "100px",
    display: "flex",
    justifyContent: "center",
  },
  crossIcon: {
    cursor: "pointer",
    width: "20px",
    fill: "#575F6B",
    top: "15px",
    right: "15px",
    position: "absolute",
  },
  contentTitle: {
    fontSize: "20px",
    fontWeight: "500",
  },
  topicMainContent: {
    display: "flex",
    gap: "5px",
    maxHeight: "300px",
    overflow: "auto",
  },
};

export default ({ latestTopic, dialogState, setDialogState }) => {
  const classes = styles;

  useEffect(() => {
    if (!dialogState) {
      return;
    }
  }, [dialogState]);

  return (
    <>
      <Modal
        closeOnEsc={false}
        closeOnOverlayClick={false}
        classNames={{
          modalContainer: "modalContainer",
          modal: "topicModalContainer",
        }}
        open={dialogState}
        showCloseIcon={false}
        onClose={() => setDialogState(false)}
      >
        {!latestTopic && (
          <div style={classes.topicLoader}>
            <Loader />
          </div>
        )}
        {latestTopic && (
          <div style={classes.topicTitleRoot}>
            <CancelIcon
              onClick={() => setDialogState(false)}
              style={classes.crossIcon}
            />
            <div style={classes.topicHeading}>Topic of the day</div>
          </div>
        )}
        {latestTopic && (
          <div
            className={"topicDialogContent customScrollArea"}
            style={{ maxHeight: "600px", overflow: "auto" }}
          >
            <div className={"topicContent"}>
              <div style={classes.topicTitle}>
                <span style={classes.contentTitle}>Name:</span>
                <img
                  alt="topicAvatar"
                  src={latestTopic?.user?.avatar}
                  style={classes.avatarClass}
                />
                <span style={classes.userName}>
                  {latestTopic?.user?.full_name}
                </span>
              </div>
              <span
                style={classes.topicMainContent}
                className="customScrollArea"
              >
                <span style={classes.contentTitle}>Topic:</span>{" "}
                <div>{latestTopic?.data?.content}</div>
              </span>
              <span>
                <span style={classes.contentTitle}>Date:</span>{" "}
                {moment(latestTopic?.created_at).format("MMM DD, YYYY")}
              </span>
            </div>
            <TopicFooter post={latestTopic} />
          </div>
        )}
      </Modal>
    </>
  );
};
